/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ShivaVnfSecuredConfiguration, ShivaVnfSecuredConfigurationParams } from './shiva-vnf-secured-configuration';

import { AuthSupportsRequestService } from './services/auth-supports-request.service';
import { VnfDashboardService } from './services/vnf-dashboard.service';
import { VnfSitesManagementService } from './services/vnf-sites-management.service';
import { VnfSitesOperationService } from './services/vnf-sites-operation.service';
import { VnfTransactionsService } from './services/vnf-transactions.service';
import { VnfAuthorizationSupportsService } from './services/vnf-authorization-supports.service';
import { VnfSubscriptionService } from './services/vnf-subscription.service';
import { WaterPreloadingService } from './services/water-preloading.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AuthSupportsRequestService,
    VnfDashboardService,
    VnfSitesManagementService,
    VnfSitesOperationService,
    VnfTransactionsService,
    VnfAuthorizationSupportsService,
    VnfSubscriptionService,
    WaterPreloadingService,
    ShivaVnfSecuredConfiguration
  ],
})
export class ShivaVnfSecuredModule {
  static forRoot(params: ShivaVnfSecuredConfigurationParams): ModuleWithProviders<ShivaVnfSecuredModule> {
    return {
      ngModule: ShivaVnfSecuredModule,
      providers: [
        {
          provide: ShivaVnfSecuredConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ShivaVnfSecuredModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ShivaVnfSecuredModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
